import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";

const Title = withLiteObserverAndTheme(() => {
  return (
    <Typography variant="subtitle1" fontWeight={fontWeights.semibold}>
      {i18n.get("CREATE_ONE_O_ONE_M")}
    </Typography>
  );
});

export default Title;
